import { Box, Grid } from "@mui/material";
import { StudentTable } from "../StudentPages/components/StudentTable";
import { useEffect, useState } from "react";
import { MeQuery, ParentalConsentType, Student } from "../../__generated__/graphql";
import { useStudentContext } from "../../context/studentContext";
import RiskWarningGrid from "./components/RiskWarningGrid";
import { useNavigate } from "react-router";
import { useSlideInContext } from "../../context/SlideInContext";
import { LAUNCH_FOR_OTHERS, LAUNCH_OPTIONS, PARENTAL_CONSENT } from "../components/SlideIn/contentTypes";
import { gql, useLazyQuery } from "@apollo/client";
import usePersonStore, { PersonModel, SubscriptionModel } from "../store/personStore";
import usePersonAuthStore from "../store/personAuthStore"
import { StudentDataType } from "../StudentPages/hooks/useSelectedStudent";
import { useManageModal } from "../Manage/components/ManageModal";
import { useUserData } from "../Manage/hooks/useUserData";
const QUERY_ME = gql(`
  query Me {
    me {
      __typename
      id
      firstName
      lastName
      company {
        __typename
        id
        name
        paidUsers
        activeUsers
        companySubscriptions{
            id
            subscription{
            id
            name
            }
        }
        companyConsentPolicy{
            needParentalConsent
            autoParentalConsent
        }
      }
      locations{
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
        edges{
            node {
                id
                name
                streetLineOne
                streetLineTwo
                city
                state
                postalCode
                country
                customFields{
                    __typename
                    id
                    type
                    name
                    position    
                }
            }
        }
      }
      defaultLocation {
        __typename
        id
        name
        streetLineOne
        streetLineTwo
        city
        state
        postalCode
        country
        customFields {
            __typename
            id
            type
            name
            position
        }
      }
    }
  }
    `);


const mapEdgesToTable = (data: any) => {
    return {
        ...data.node,
        location: data.node
    }
}
function transformToState(data: MeQuery): PersonModel {
    return {
        id: data.me?.id,
        name: `${data.me?.firstName} ${data.me?.lastName}`,
        company: {
            id: data.me?.company.id,
            name: `${data.me?.company.name}`,
            paidUsers: data.me?.company.paidUsers,
            activeUsers: data.me?.company.activeUsers,
            defaultLocation: (data.me?.defaultLocation as any),
            subscriptions: data.me?.company.companySubscriptions.map(x => x.subscription as SubscriptionModel) ?? [],
            consentPolicy: data.me?.company.companyConsentPolicy.needParentalConsent ?? false,
            parentEmailNeeded: data.me?.company.companyConsentPolicy.autoParentalConsent ?? false
        },
        locations: data?.me?.locations?.edges?.map(mapEdgesToTable) ?? [] as any
    }
}


export function DashboardPage() {
    const navigate = useNavigate();
    const { changeStudent, studentData } = useStudentContext();
    const { handleContent } = useSlideInContext();
    const { openModal } = useManageModal();
    const [activeRecord, setActiveRecord] = useState<Student | null>(null);
    const roles = usePersonAuthStore((state) => state.roles);
    const [queryMe] = useLazyQuery(QUERY_ME, { notifyOnNetworkStatusChange: true });
    const personState = usePersonStore(state => state)
    const { loading, FetchUserData } = useUserData()
    useEffect(() => {
        FetchUserData()
        console.log("testing this, ", loading)
    }, [])
    const setPersonStoreState = usePersonStore(state => state.setState);
    useEffect(() => {
        queryMe().then(response => setPersonStoreState(transformToState(response.data)));
    }, []);
    const handleSelectedStudent = (student: StudentDataType) => {
        changeStudent(student)
        navigate(`/dashboard/student/${student?.id}/sessions`)
    }
    const handleStudentDetails = (student: StudentDataType) => {
        changeStudent(student)
        navigate(`/manage/children/details/${student?.id}`)
    }

    const handleActionItem = (record: any) => {
        //@ts-ignore
        const edge = activeRecord?.students?.edges?.find(item => item.node.id === record.studentId) as StudentsEdge
        navigate(`/dashboard/student/${record.studentId}/sessions`)
        if (edge) {
            setActiveRecord(edge.node)
        }
    }

    const handleLaunch = (student: any) => {
        if (student?.expired) {
            openModal({
                type: 'STUDENT_IS_EXPIRED',
                cancelButtonLabel: "Close"
            })
        }
        else {
            changeStudent(student);
            const studentConsentStatus = student.parentalConsentStatus?.toUpperCase() ?? null;
            if (personState.company.consentPolicy && (studentConsentStatus !== ParentalConsentType.Given && studentConsentStatus !== ParentalConsentType.Timelapsed)) {
                if (!studentConsentStatus) {
                    handleContent(PARENTAL_CONSENT)
                } else if (studentConsentStatus === ParentalConsentType.Pending) {
                    handleContent(PARENTAL_CONSENT)
                    // openModal({ type: "PARENTAL_CONSENT_PENDING", cancelButtonLabel: "close" })
                } else {
                    openModal({ type: "PARENTAL_CONSENT_NOT_GIVEN", cancelButtonLabel: "close" })
                }
            }
            else if (roles.includes("OFFICE ADMIN") || roles.includes("SUPER ADMIN")) {
                handleContent(LAUNCH_FOR_OTHERS)
                // TODO: ADD A NEW FUNCTION TO ALLOW THEM TO LAUNCH ON BEHALF OF OTHERS
            } else {
                handleContent(LAUNCH_OPTIONS);
            }
        }
    }

    // useEffect(() => {
    //     console.log("student data is: ", studentData)
    // }, [studentData])
    return (
        <Grid container rowSpacing={4} sx={{ paddingBottom: 4 }}>
            <Grid size={8}>
                <Box component="div" sx={{ marginTop: 4 }}>
                    <RiskWarningGrid onClickResults={handleActionItem} />
                </Box>
            </Grid>
            <Grid size={12}>
                <StudentTable
                    title={`${!roles.includes("OFFICE ADMIN") ? "Your Children" : "Children"}`}
                    showNew={false}
                    onSelectedStudent={(student, action) => {
                        switch (action) {
                            case "LAUNCH":
                                handleLaunch(student)
                                break;
                            case "REPORTS":
                                handleSelectedStudent(student)
                                break;
                            case "DETAILS":
                                handleStudentDetails(student)
                                break;
                            default:
                                throw Error(`Although the student ${student.id} is selected, action ${action} is not implemented`);
                        }
                    }}
                />
            </Grid>
        </Grid>
    )
}